import apiFetch, { type APIFetchOptions } from '@wordpress/api-fetch';

apiFetch.use((options, next) => {
    const nonce = (window as any).openDayMapData?.nonce;
    if (nonce) {
        options.headers = {
            ...options.headers,
            'X-WP-Nonce': nonce,
        };
    }
    return next(options);
});

export async function wordpressFetch<T = unknown>(options: APIFetchOptions): Promise<T> {
    const fetchOptions: APIFetchOptions = { ...options };
    const isProductionHost = window.location.hostname === 'www.curtin.edu.au';

    if (import.meta.env.DEV && options.path?.startsWith('/')) {
        // Only prepend the URL if it's a relative path
        fetchOptions.url = `https://open-day.ddev.site${options.path}`;
        delete fetchOptions.path;
    } else if (isProductionHost && options.path?.startsWith('/')) {
        // Prepend /open-day/ for the production host
        // Note: Ensure we don't double-prepend if the path already has it
        const pathWithPrefix = options.path.startsWith('/open-day/')
            ? options.path
            : `/open-day${options.path}`;

        fetchOptions.path = pathWithPrefix;
    }

    return await apiFetch(fetchOptions) as T;
}

export async function fetcher<T>(endpoint: string): Promise<T> {
    const response = await wordpressFetch<T>({
        path: `${endpoint}`,
        credentials: 'include',
    });
    return response;
}
